(() => {
  const normalizeMenu = () => {
    document.querySelectorAll('.cqz-fallback-nav a').forEach((link) => {
      const label = link.textContent.trim();
      if (label === 'Home') link.textContent = 'Accueil';
      if (label === 'Beauté' || label === 'Beauty') link.textContent = 'Soins';
      if (link.textContent.trim() === 'Soins' && /\/collections\/soins(?:$|[/?#])/.test(link.getAttribute('href') || '')) {
        link.setAttribute('href', '/collections/beaute');
      }
    });
  };

  const normalizeSoinsText = () => {
    if (!/\/collections\/beaute(?:$|[/?#])/.test(window.location.pathname)) return;
    document.querySelectorAll('h1, h2, h3, a, span, .hdt-collection-title, .breadcrumb, .breadcrumbs, [class*="breadcrumb"], [class*="title"], [class*="slide"]').forEach((element) => {
      element.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.nodeValue) {
          node.nodeValue = node.nodeValue
            .replaceAll('Beauté', 'Soins')
            .replaceAll('Beauty', 'Soins');
        }
      });
    });
    document.title = document.title
      .replaceAll('Beauté', 'Soins')
      .replaceAll('Beauty', 'Soins');
  };

  const normalizeFrenchLabels = () => {
    document.querySelectorAll('h1, h2, h3, h4, summary, button, label, span, a, legend').forEach((element) => {
      element.childNodes.forEach((node) => {
        if (node.nodeType !== Node.TEXT_NODE || !node.nodeValue) return;
        if (node.nodeValue.trim() === 'Product categories') {
          node.nodeValue = node.nodeValue.replace('Product categories', 'Catégories de produits');
        }
      });
    });
  };

  const redirectBrokenBestsellers = () => {
    if (!/\/collections\/meilleures-ventes\/?$/.test(window.location.pathname)) return;
    const pageText = document.body ? document.body.textContent : '';
    const is404 =
      document.title.includes('404') ||
      /\b404\b/.test(pageText) ||
      pageText.includes('PAGE QUE VOUS RECHERCHEZ EST INTROUVABLE');
    if (is404) {
      window.location.replace('/collections/all');
    }
  };

  const initDesktopDropdownClick = () => {
    if (window.matchMedia('(max-width: 767px)').matches) return;
    document.querySelectorAll('.cqz-fallback-nav-item--has-dropdown > a').forEach((link) => {
      if (link.dataset.cqzDropdownClickReady === 'true') return;
      link.dataset.cqzDropdownClickReady = 'true';
      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', 'false');
      link.addEventListener('click', (event) => {
        const item = link.closest('.cqz-fallback-nav-item--has-dropdown');
        if (!item) return;
        const isOpen = item.classList.contains('cqz-dropdown-open');
        document.querySelectorAll('.cqz-fallback-nav-item--has-dropdown.cqz-dropdown-open').forEach((openItem) => {
          if (openItem !== item) {
            openItem.classList.remove('cqz-dropdown-open');
            openItem.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
          }
        });
        if (!isOpen) {
          event.preventDefault();
          item.classList.add('cqz-dropdown-open');
          link.setAttribute('aria-expanded', 'true');
        }
      });
    });
  };

  const initLanguageSwitch = () => {
    return;
  };

  const removeDefaultTitle = (root = document) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.nodeValue && node.nodeValue.trim() === 'Default Title') {
        nodes.push(node);
      }
    }
    nodes.forEach((node) => {
      const parent = node.parentElement;
      node.nodeValue = '';
      if (parent && parent.textContent.trim() === '') {
        parent.style.display = 'none';
      }
    });
  };

  const runCleanup = () => {
    normalizeMenu();
    normalizeSoinsText();
    normalizeFrenchLabels();
    redirectBrokenBestsellers();
    initDesktopDropdownClick();
    removeDefaultTitle();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runCleanup, { once: true });
  } else {
    runCleanup();
  }

  document.addEventListener('shopify:section:load', runCleanup);
  document.addEventListener('shopify:section:select', runCleanup);
  document.addEventListener('click', (event) => {
    if (event.target.closest('.cqz-fallback-nav-item--has-dropdown')) return;
    document.querySelectorAll('.cqz-fallback-nav-item--has-dropdown.cqz-dropdown-open').forEach((item) => {
      item.classList.remove('cqz-dropdown-open');
      item.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
    });
  });

  const observer = new MutationObserver(() => runCleanup());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

(() => {
  if (window.CQZMainHeaderSmartStickyReady) return;
  window.CQZMainHeaderSmartStickyReady = true;

  let lastScrollY = window.scrollY || 0;
  let hideTimer = null;
  const threshold = 10;
  const topOffset = 80;
  const hideDelay = 300;

  const getMainWhiteHeader = () => document.querySelector('.cqz-fallback-main');

  const cleanupOuterHeaderClasses = () => {
    document
      .querySelectorAll('.cqz-fallback-header, .cqz-fallback-announcement, .cqz-fallback-service')
      .forEach((element) => {
        element.classList.remove(
          'cqz-smart-header',
          'cqz-header-visible',
          'cqz-header-hidden',
          'cqz-main-header-visible',
          'cqz-main-header-hidden',
          'shopify-section-header-hidden'
        );
        if (element !== getMainWhiteHeader()) {
          element.style.transform = '';
        }
      });
  };

  const showMainHeader = (header) => {
    header.classList.remove('cqz-main-header-hidden');
    header.classList.add('cqz-main-header-visible');
  };

  const hideMainHeader = (header) => {
    header.classList.add('cqz-main-header-hidden');
    header.classList.remove('cqz-main-header-visible');
  };

  const handleScroll = () => {
    const header = getMainWhiteHeader();
    if (!header) return;

    cleanupOuterHeaderClasses();

    const currentScrollY = window.scrollY || 0;
    const diff = currentScrollY - lastScrollY;

    if (currentScrollY < topOffset) {
      clearTimeout(hideTimer);
      showMainHeader(header);
      lastScrollY = currentScrollY;
      return;
    }

    if (Math.abs(diff) < threshold) return;

    if (diff > 0) {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        hideMainHeader(header);
      }, hideDelay);
    } else {
      clearTimeout(hideTimer);
      showMainHeader(header);
    }

    lastScrollY = currentScrollY;
  };

  const initMainHeader = () => {
    const header = getMainWhiteHeader();
    if (!header) return;
    cleanupOuterHeaderClasses();
    showMainHeader(header);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMainHeader, { once: true });
  } else {
    initMainHeader();
  }

  window.addEventListener('pageshow', initMainHeader);
  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', initMainHeader, { passive: true });
})();
(() => {
  if (window.CQZSoinsDirectLinkReady) return;
  window.CQZSoinsDirectLinkReady = true;

  document.addEventListener(
    'click',
    (event) => {
      if (
        !(event.target instanceof Element) ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) return;

      const link = event.target.closest(
        '.cqz-fallback-nav a[href="/collections/beaute"], .cqz-mobile-menu-panel a[href="/collections/beaute"]'
      );

      if (!link) return;

      event.preventDefault();
      window.location.assign(link.href);
    },
    true
  );
})();